import { FC } from 'react'
import { Switch } from '@wellesley/ui'

import { TDisabledCommentsMenu } from '../types'

const AllowCommentsMenu: FC<TDisabledCommentsMenu> = ({
  isAllowedComments,
  onAllowComments,
}) => (
  <>
    <div className="m-auto h-[1px] w-[200px] border-t border-dashed border-gray-300" />
    <div
      data-testid="disable-comment-toggler"
      className="flex cursor-pointer flex-col gap-0.5 px-2 pb-1"
      onClick={onAllowComments}
    >
      <div className="flex flex-col gap-0.5">
        <div className="flex items-center justify-between gap-2">
          <span className="text-base font-semibold">Allow to comment</span>
          <Switch className="pointer-events-none" checked={isAllowedComments} />
        </div>
      </div>
    </div>
  </>
)

export default AllowCommentsMenu
